module.exports = __webpack_public_path__ + "img/pic1.31db7a31.png";